import { getUrlParameters, newURLSearchParams } from "../utilities/urlHelper";
import { useState, useEffect, useRef } from "react";
const useUrlParamsContext = () => {
  const [urlParams, setUrlParams] = useState({}); //urlParams, setUrlParams
  const landingParams = useRef({});

  useEffect(() => {
    landingParams.current = getUrlParameters();
    setUrlParams(landingParams.current);

    // The landing page's params (external attribution such as utm_*) last the whole visit, and the
    // current URL's params win over them (e.g. the campaign id on a donate button). Params picked up
    // on pages in between drop away, so amount/selection from a campaign form don't leak into later links.
    const handleUrlChange = () => {
      setUrlParams({ ...landingParams.current, ...getUrlParameters() });
    };

    // Gatsby <Link> navigation fires no popstate, so gatsby-browser.js onRouteUpdate signals it
    window?.addEventListener("popstate", handleUrlChange);
    window?.addEventListener("starlight:route-update", handleUrlChange);

    return () => {
      window?.removeEventListener("popstate", handleUrlChange);
      window?.removeEventListener("starlight:route-update", handleUrlChange);
    };
  }, []);

  /**
   * this does the following thing,
   * 1. update the urlParams variable
   * 2. update the param to browser search bar
   * 3. remove the param to browser search bar if its empty
   * @param {*} newParams
   * @param {boolean} syncUrl if false skip the point 2 & 3
   * @param {boolean} reload if true reload the page after updating the urlParams
   * @return {void}
   */
  const updateUrlParams = (newParams, syncUrl = true, reload = false) => {
    if (!syncUrl) {
      setUrlParams({
        ...urlParams,
        ...newParams,
      });
      return;
    }

    const updatedParams = newURLSearchParams(window?.location.search);

    Object.keys(newParams).forEach((key) => {
      if (newParams[key] === "" || newParams[key] == null) {
        updatedParams.delete(key); // Remove the param if it's empty
      } else {
        updatedParams.set(key, newParams[key]);
      }
    });

    // Update the browser URL without reloading the page
    const newQueryString = updatedParams.toString();
    window?.history.pushState({}, "", newQueryString ? `?${newQueryString}` : window?.location.pathname);

    setUrlParams(getUrlParameters());
    if (reload) {
      window.location.reload();
    }
  };

  return { urlParams, updateUrlParams };
};

export default useUrlParamsContext;
